import { modifier } from 'ember-modifier';

export default modifier((element, [ callback ]) => {
  function handleKeyUp(event) {
    if (event.defaultPrevented) {
      return;
    }
    if (event.keyCode === 13 || event.key === 'Enter') {
      callback();
      event.preventDefault();
    }
  }
  element.addEventListener('keyup', handleKeyUp);
  return () => element.removeEventListener('keyup', handleKeyUp);
});
